import { createFileRoute } from '@tanstack/react-router';

import { MyEarningsPage } from '@/features/me/my-work';

export const Route = createFileRoute('/_app/me/earnings')({ component: MyEarningsPage });
